module.exports = __webpack_public_path__ + "static/media/bert-stedman-for-senate-construction.c31f8954.png";